<template>
  <div>
    <PageTitle titleText="申し込みフォーム管理"></PageTitle>
    <p>
      <el-button type="primary" icon="el-icon-circle-plus" @click="onEdit()"
        >新規申し込みフォーム</el-button
      >
    </p>
    <el-table :data="result.data.docs" stripe style="width: 100%">
      <el-table-column label="公開" width="80"
        ><template slot-scope="scope">
          <span style="margin-left: 10px">{{
            scope.row.isPublished ? "公開" : "非公開"
          }}</span>
        </template></el-table-column
      >
      <el-table-column prop="name" label="タイトル"> </el-table-column>
      <el-table-column label="フォーム" width="200"
        ><template slot-scope="scope">
          <span>
            {{ scope.row.directory }}
          </span>
        </template></el-table-column
      >
      <!-- <el-table-column prop="start_at" label="開始"> </el-table-column>
      <el-table-column prop="end_at" label="終了"> </el-table-column> -->
      <el-table-column fixed="right" label="操作" fit="true" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="onEdit(scope.row._id)"
            >編集</el-button
          >
          <!-- <el-button type="text" size="small" @click="onRmove(scope.row._id)"
            >削除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="result.totalDocs"
      :page-size="result.limit"
      @current-change="onCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import OrderSchemaService from "../../../services/order-schema.service";
import Admin from "../../../mixin/guard/admin";
import PageTitle from "@/components/PageTitle.vue";
export default {
  mixins: [Admin],
  components: {
    PageTitle,
  },
  data() {
    return {
      result: { data: [] },
    };
  },
  async mounted() {
    // await this.$nextTick();
    this.result = await OrderSchemaService.list({
      mansion: this.$route.params.mc_code,
    });
    console.log(this.result.data);
  },
  methods: {
    async onCurrentChange(page) {
      // console.log(page);
      this.result = await OrderSchemaService.list({
        mansion: this.$route.params.mc_code,
        page: page,
      });
    },
    onEdit(id) {
      console.log(id);
      this.$router.push({
        name: "admin-order-schema-edit",
        params: { id: id, mc_code: this.currentUser.mansion._id },
      });
    },
  },
};
</script>

<style></style>
